import { useChatbot } from '@/feature/chatbot/useChatbot';
import { useCallback, useRef, useState } from 'react';
import { ChatbotButton } from './ChatbotButton';
import { ChatWindow } from './ChatWindow';

export const ChatbotContainer = () => {
  const { isAvailable, isOpen, setIsOpen } = useChatbot();
  const [customWidth, setCustomWidth] = useState<number | undefined>(undefined);
  const [customHeight, setCustomHeight] =
    useState<number | undefined>(undefined);
  const chatWindowRef = useRef<HTMLDivElement>(null);

  const handleResize = useCallback((width: number, height: number) => {
    setCustomWidth(width);
    setCustomHeight(height);
  }, []);

  const handleClose = useCallback(() => {
    setIsOpen(false);
    setCustomWidth(undefined);
    setCustomHeight(undefined);
  }, [setIsOpen]);

  if (!isAvailable) {
    return null;
  }

  return (
    <>
      {isOpen ? (
        <ChatWindow
          ref={chatWindowRef}
          onClose={handleClose}
          customWidth={customWidth}
          customHeight={customHeight}
          onResize={handleResize}
        />
      ) : (
        <ChatbotButton onClick={() => setIsOpen(true)} />
      )}
    </>
  );
};
